


































































import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { Errors } from '@/dto/ErrorsResponse'
import { Routes } from '@/router/routes'
import Limit from '@/dto/limits/Limit'
import limitsStore from '@/stores/LimitsStore'
import LocationService from '@/services/LocationService'
import DictionariesService from '@/services/DictionariesService'
import Currency from '@/dto/deliveries/Currency'
import Country from '@/dto/deliveries/Country'
import LimitDeleteForm from '@/components/limit/LimitDeleteForm.vue'

@Component({
  components: { LimitDeleteForm },
})
export default class LimitForm extends Vue {
  @Prop(Object)
  model: Limit

  countries: Country[] = []
  countriesOptions: any = null
  limitsStore = limitsStore
  isPending: boolean = false
  isShowConfirmDialog: boolean = false
  isDisabledBtn: boolean = true
  dictionaries = DictionariesService

  created() {
    LocationService.getCountries().then(countries => {
      this.countries = countries
      this.setCountriesOptions(countries)
    })
  }

  get errors(): Errors {
    return this.limitsStore.errors
  }

  async saveLimit() {
    this.isPending = true
    const newLimit = (await this.limitsStore.saveLimit(this.model)) as Limit
    this.isPending = false

    if (this.model.id === null) {
      this.$router.push({
        name: Routes.limitEdit,
        params: { limitId: (newLimit.id as number).toString() },
      })
    }
  }

  get country() {
    return this.countries.find(
      country => country.id === (this.model.countryId as number)
    )
  }

  get currentCurrency(): Currency | null {
    if (!this.model.currency) {
      return null
    }

    return this.dictionaries.currencies[this.model.currency]
  }

  get currenciesOptions() {
    return this.dictionaries.getCurrenciesOptions()
  }

  filterCountries(query: string, update: Function, abort: Function) {
    if (query.length === 0) {
      abort()
      return
    }
    LocationService.getCountries().then(countries =>
      update(() => this.setCountriesOptions(countries, query))
    )
  }

  setCountriesOptions(countries: Country[], query: string = '') {
    this.countriesOptions = countries
      .filter(
        country =>
          country.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
      )
      .map(country => ({
        label: country.name,
        value: country.id,
      }))
  }

  @Watch('model', { deep: true })
  watchFields(model: Limit, oldModel: Limit) {
    this.isDisabledBtn = model.id !== oldModel.id
  }
}
